import { fmt } from "../lib/api";
import { useFetch } from "../lib/useFetch";
import { Panel, Spinner } from "./common";

const tone = (r) => (r == null ? "" : r <= 0.25 ? "text-emerald-600" : r <= 1 ? "text-amber-600" : "text-red-600");

export const FeeEfficiency = () => {
  const { data } = useFetch("/fees/efficiency");
  return (
    <Panel title="Lowest fees vs usual price move" className="mb-3" testid="fee-efficiency">
      {!data ? <Spinner /> : (
        <>
          <p className="mb-2 text-xs text-slate-600" data-testid="fee-budget">Trade size RM{fmt(data.trade_budget_myr, 2)} (from Moomoo total assets RM{fmt(data.capital_myr, 2)}).</p>
          <div className="custom-scrollbar max-h-96 overflow-auto"><table className="tbl w-full" data-testid="fee-table">
            <thead><tr><th>Stock</th><th>Market</th><th>Qty</th><th>Trade RM</th><th>Fees in+out</th><th>Fees %</th><th>Daily move</th><th>Fee vs move</th></tr></thead>
            <tbody>{data.rows.map((r) => (
              <tr key={r.symbol} data-testid={`fee-row-${r.symbol}`} className={r.affordable ? "" : "opacity-60"}>
                <td><span className="mono font-semibold">{r.symbol}</span> <span className="text-[10px] text-slate-500">{r.name}</span></td>
                <td className="mono">{r.exchange}</td>
                <td className="mono">{r.affordable ? r.qty : <span className="text-[10px]">1 lot = RM{fmt(r.one_lot_myr, 0)}</span>}</td>
                <td className="mono">{fmt(r.notional_myr, 2)}</td><td className="mono">RM{fmt(r.round_trip_fee_myr, 2)}</td>
                <td className="mono">{fmt(r.fee_pct, 2)}%</td><td className="mono">{fmt(r.daily_move_pct, 2)}%</td>
                <td className={`mono font-bold ${tone(r.fee_vs_move)}`} data-testid={`fee-ratio-${r.symbol}`}>{r.fee_vs_move ?? "—"}</td>
              </tr>))}
            </tbody></table></div>
          <p className="mt-2 text-[10px] text-slate-500">{data.note} Greyed rows: one lot costs more than your trade size.</p>
        </>
      )}
    </Panel>
  );
};
